import { graphql } from 'react-relay';

const mutation = graphql`
  mutation mobilePhoneNotificationSubscriptionMutation(
    $input: PackageTrackerNotificationSubscriptionMutationInput!
  ) {
    packageTrackerNotificationSubscription(input: $input) {
      shouldValidateToken
      success
      errors {
        field
        message
      }
    }
  }
`;

export default mutation;
